import { AutogenModelRateLookup, AutogenRowRateLookup } from "./autogen/AutogenModelRateLookup";

export class ModelRateLookup extends AutogenModelRateLookup<RowRateLookup> {
	constructor() {
		super(RowRateLookup);
	}
}

export class RowRateLookup extends AutogenRowRateLookup {
}